import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import Logo from "../assets/logo.png";
// import Cart from "../assets/header_cart.svg";
import Downarrow from "../assets/downarrow.svg";
import Downarrow_Dim from "../assets/downarrow_dim.svg";
import Next from "../assets/next.svg";
import ProfileMenu from "./ProfileMenu";
import SideMenuWrap from "./SideMenuWrap";
import { hasAccess } from "../../config/helper";
// import Notifications from "./Notifications";

const NavBar = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [show, setShow] = useState({});
  const [open, setOpen] = useState(false);
  const nav = [
    {
      name: "Customers",
      to: "/customers",
      hasAccess: hasAccess("customers")
    },
    {
      name: "Admins",
      to: "/admins",
      hasAccess: hasAccess("admins")
    },
    {
      name: "Manage Products",
      to: "/products",
      hasAccess: hasAccess("products")
      // more: true,
      // options: [
      //   {
      //     name: "Manage Products",
      //     to: "/products",
      //   },
      //   {
      //     name: "Inventory FTL",
      //     to: "/inventory",
      //   },
      // ],
    },
    {
      name: "Marketing",
      to: "/marketing",
      hasAccess: hasAccess("marketing")
    },
    {
      name: "Sales Order",
      to: "/orders",
      hasAccess: hasAccess("orders")
    }
    //   // more: true,
    //   options: [
    //     {
    //       name: "Manage Orders",
    //       to: "/orders",
    //     },
    //     // {
    //     //   name: "Shipment Status",
    //     //   to: "/track-shipments",
    //     // },
    //     // {
    //     //   name: "Payments",
    //     //   to: "/payments",
    //     // },
    //     // {
    //     //   name: "FTL Orders",
    //     //   to: "/ftl-orders",
    //     // },
    //   ],
    // },
    // {
    //   name: "Claims",
    //   to: "/claims",
    //   more: true,
    //   options: [
    //     {
    //       name: "Warranties",
    //       to: "/warranties",
    //     },
    //     {
    //       name: "My Claims",
    //       to: "/claims",
    //     },
    //     {
    //       name: "Transactions",
    //       to: "/transactions",
    //     },
    //   ],
    // },
    // {
    //   name: "My Profile",
    //   to: "/settings",
    //   more: true,
    //   options: [
    //     {
    //       name: "User & Roles",
    //       to: "/user-roles",
    //     },
    //     {
    //       name: "Settings",
    //       to: "/settings",
    //     },
    //   ],
    // },
  ];

  return (
    <div className="nav-bar">
      <nav className="flex-between">
        <ul className="links">
          <li>
            <img src={Logo} width={150} alt={"logo"} />
          </li>
          {nav.map((ele) => (
            ele.hasAccess && <li
              className={location.pathname.includes(ele.to) ? `active` : ""}
              onClick={() => {
                if (!ele.more) {
                  history.push("/admin" + ele.to);
                }
                if (ele.more) {
                  setShow({
                    [ele.name]: !show[ele.name],
                  });
                }
              }}
            >
              {ele.name}
              {ele.more && (
                <img
                  className={`more`}
                  src={
                    location.pathname.includes(ele.to)
                      ? Downarrow
                      : Downarrow_Dim
                  }
                  width={7}
                  alt="more"
                />
              )}
              {ele.more && show[ele.name] && (
                <ul className="more-options">
                  {ele.options &&
                    ele.options.map((ele, i) => (
                      <li
                        className={i === 0 ? "sub-active" : ""}
                        onClick={() => {
                          history.push("/admin" + ele.to);
                        }}
                      >
                        {ele.name}
                      </li>
                    ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <ul className="flex-center">
          <li className="name" onClick={() => {
            setOpen((bool) => !bool);
          }}>
            <span className="circle">{localStorage.getItem("email")?.[0]}</span>
            <span className="nm">{localStorage.getItem("email")?.substring(0, 18) + "..."}</span>
            <img src={Next} alt="next" />
          </li>
        </ul>
      </nav>
      {open && (
        <SideMenuWrap>
          {/* <Notifications /> */}
          <ProfileMenu setOpen={setOpen} />
        </SideMenuWrap>
      )}
    </div>
  );
};

export default NavBar;
